import ContextModalDetailsBox from "./ContextModalDetailsBox";
export default ContextModalDetailsBox;
